<div class="container addArtifactory">
  <div class="row">

    <div class="col-12 col-md-12 col-lg-12 col-xl-12 p-2 mt-2 mb-4 unq  ">
      <div class="card">

        <h1 mat-dialog-title class="d-flex align-items-center justify-content-between">
          <span>{{title}} Artifactory </span>
          <i class="fa fa-times model_close cursor-pointer" (click)="cancel()"></i>
        </h1>

        <form mat-dialog-content class="popup-content model_form" [formGroup]="formData" cdkScrollable>
          <div class="row m-0">
            <div class="col-md-6 pl-md-0 pb-20">
              <div class="field_heading">
                <span class="labelName">Do you have COE approval for this Artifactory?</span>
              </div>
              <mat-radio-group formControlName="hasApproval">
                <mat-radio-button [value]="true">Yes</mat-radio-button>
                <mat-radio-button [value]="false">No</mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="col-md-6 pl-md-0 pb-20" [ngClass]="{'disabled': !hasApproval}"
              [style.opacity]="hasApproval ? 1 : 0.5">
              <div><span class="labelName">Git Mail Proof Url<sup class="error">*</sup></span>
              </div>
              <input type="text" class="form-control" placeholder="Enter Mail Proof Uploaded URL"
                formControlName="MailProofFile" (keyup)="Onchange()">
              <div
                *ngIf="(formData.get('MailProofFile').invalid && formData.get('MailProofFile').touched && formData.get('MailProofFile').hasError)||flag">
                <div class="error" *ngIf="formData.get('MailProofFile').hasError('required')">Git Mail Proof Uploaded File URL is required
                </div>
                <div class="error" *ngIf="formData.get('MailProofFile').hasError('pattern')">
                   Git Mail Proof Uploaded File URL is invalid
                </div>
              </div>
            </div>
          </div>

          <div class="pb-3 mt-4 border-top"></div>

          <div class="pl-md-0 pb-20" [ngClass]="{'disabled': !hasApproval}" [style.opacity]="hasApproval ? 1 : 0.5">
            <div class="row m-0">
              <div class="col-12 p-0">
                <div class="row ">
                  <div class="col-12 col-md-4 col-lg-4 mb-2">
                    <div>
                      <span class="labelName">Artifactory Name <sup class="requiredStar">*</sup></span>
                    </div>
                    <input type="text" class="form-control"
                      [class.is-invalid]="formData.get('Name').invalid && formData.get('Name').touched && formData.get('Name').errors"
                      (keyup)="Onchange()" placeholder="Enter Name" formControlName="Name" maxlength="50">
                    <div
                      *ngIf="(formData.get('Name').invalid && formData.get('Name').touched && formData.get('Name').hasError)||flag">
                      <div class="error" *ngIf="formData.get('Name').hasError('required')">Name is required
                      </div>
                      <div class="error" *ngIf="formData.get('Name').hasError('pattern')">Only Alphabets are Allowed
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4 mb-2">
                    <div>
                      <span class="labelName">Artifactory Category <sup class="requiredStar">*</sup></span>
                      <div aria-label="your label" class="add-icon " (click)="TemplateCategoryDialog()">
                        <span class="material-symbols-outlined"> add_circle </span>
                      </div>
                    </div>

                    <mat-form-field class="custom_select"
                      [class.is-invalid]="formData.get('templateId').invalid && formData.get('templateId').touched && formData.get('templateId').errors">
                      <mat-select placeholder="Select the data.." formControlName="templateId"
                        (selectionChange)="templateCategoryChange($event)">
                        <mat-option *ngFor="let category of templates"
                          [value]="category.id">{{category.category}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div
                      *ngIf="(formData.get('templateId').invalid && formData.get('templateId').touched && formData.get('templateId').errors)||flag">
                      <div class="error" *ngIf="formData.get('templateId').hasError('required')">Category is
                        required</div>
                    </div>
                  </div>

                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2 ">
                      <span class="labelName">Artifactory Category Type</span>
                      <div *ngIf="istemplateselected" aria-label="your label" class="add-icon"
                        (click)="SubTemplateCategoryDialog()">
                        <span class="material-symbols-outlined"> add_circle </span>
                      </div>
                    </div>
                    <mat-form-field class="custom_select">
                      <mat-select placeholder="Select the data.." formControlName="SubCategoryTemplateId"
                        [disabled]="!istemplateselected" [(ngModel)]="this.data.subCategoryTemplateId">
                        <mat-option *ngFor="let subtemp of subTemplates"
                          [value]="subtemp.id">{{subtemp.subCategory}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                </div>
                <div class="row ">
                  <div class="col-12 col-lg-4 col-md-4 mb-2">
                    <div>
                      <div>
                        <span class="labelName">Description <sup class="requiredStar">*</sup></span>
                      </div>
                      <input type="text" class="form-control"
                        [class.is-invalid]="formData.get('TemplateDescription').invalid && formData.get('TemplateDescription').touched && formData.get('TemplateDescription').errors"
                        (keyup)="Onchange()" placeholder="Enter Description" minlength="30" maxlength="150"
                        formControlName="TemplateDescription">
                    </div>
                    <div
                      *ngIf="(formData.get('TemplateDescription').invalid && (formData.get('TemplateDescription').touched || formData.get('TemplateDescription').dirty)) || flag">
                      <div class="error"
                        *ngIf="formData.get('TemplateDescription').hasError('required') && (formData.get('TemplateDescription').touched || formData.get('TemplateDescription').dirty)">
                        Description is required
                      </div>
                      <div class="error"
                        *ngIf="formData.get('TemplateDescription').hasError('pattern') && !formData.get('TemplateDescription').hasError('required')">
                        Invalid format
                      </div>
                      <div class="error"
                        *ngIf="formData.get('TemplateDescription').hasError('minlength') && !formData.get('TemplateDescription').hasError('required') && !formData.get('TemplateDescription').hasError('pattern')">
                        Min length is 30
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4 mb-2">
                    <div>
                      <div>
                        <span class="labelName">Purpose of Usage<sup class="requiredStar">*</sup></span>
                      </div>
                      <input type="text" class="form-control"
                        [class.is-invalid]="formData.get('purposeOfUsage').invalid && formData.get('purposeOfUsage').touched && formData.get('purposeOfUsage').errors"
                        (keyup)="Onchange()" placeholder="Enter Purpose of Usage" maxlength="150"
                        formControlName="purposeOfUsage">
                    </div>
                    <div
                      *ngIf="(formData.get('purposeOfUsage').invalid && (formData.get('purposeOfUsage').touched || formData.get('purposeOfUsage').dirty)) || flag">
                      <div class="error"
                        *ngIf="formData.get('purposeOfUsage').hasError('required') && (formData.get('purposeOfUsage').touched || formData.get('purposeOfUsage').dirty)">
                        Purpose of Usage is required
                      </div>
                      <div class="error"
                        *ngIf="formData.get('purposeOfUsage').hasError('pattern') && !formData.get('purposeOfUsage').hasError('required')">
                        Invalid format
                      </div>
                    </div>
                  </div>
                </div>

                <div class="pb-3 mt-4 border-top"></div>

                <div class="row">

                  <div class="col-4 mb-2">
                    <div class="pr-2 ">
                      <span class="labelName">Vertical <sup class="requiredStar">*</sup></span>
                    </div>

                    <mat-form-field class="custom_select"
                      [class.is-invalid]="formData.get('Domain').invalid && formData.get('Domain').touched && formData.get('Domain').errors">
                      <mat-select placeholder="Select the data.." formControlName="Domain">
                        <mat-option *ngFor="let category of domains" [value]="category">{{category}}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <div
                      *ngIf="(formData.get('Domain').invalid && formData.get('Domain').touched && formData.get('Domain').errors)||flag">
                      <div class="error" *ngIf="formData.get('Domain').hasError('required')">Domain is
                        required</div>
                    </div>
                  </div>

                </div>
                <div class="row">

                  <div class="col-4 mb-2">
                    <div>
                      <div><span class="labelName">Service Line <sup class="requiredStar">*</sup></span></div>
                    </div>

                    <div class="input-with-icon">
                      <input type="text" placeholder="Select Service Line" class="form-control inp" aria-label="Number"
                        matInput formControlName="serviceLineName" (ngModel)="this.data.serviceLineName"
                        [class.is-invalid]="formData.get('serviceLineName').invalid && formData.get('serviceLineName').touched && formData.get('serviceLineName').errors"
                        (input)="filterServiceLineValues($event.target.value)" [matAutocomplete]="auto">
                    </div>
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                      (optionSelected)="getServiceLinesForDropDownvalues($event)">
                      <mat-option *ngFor="let category of serviceLinesForDropDown" [value]="category.name">
                        {{ category.name }}
                      </mat-option>
                    </mat-autocomplete>

                    <div
                      *ngIf="(formData.get('serviceLineName').invalid && formData.get('serviceLineName').touched && formData.get('serviceLineName').errors)||flag">
                      <div class="error" *ngIf="formData.get('serviceLineName').hasError('required')">Service Line is
                        required</div>
                    </div>
                  </div>

                  <div class="col-4 mb-2">
                    <div>
                      <span class="labelName">Service Offering <sup class="requiredStar">*</sup></span>
                    </div>
                    <mat-form-field class="custom_select "
                      [class.is-invalid]="formData.get('ServiceOffering').invalid && formData.get('ServiceOffering').touched && formData.get('ServiceOffering').errors">
                      <mat-select placeholder="Select the data.." formControlName="ServiceOffering"
                        [(ngModel)]="this.data.serviceOffering">
                        <mat-option *ngFor="let category of serviceOfferingForDropDownValues"
                          [value]="category.id + 1">{{category.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <div
                      *ngIf="(formData.get('ServiceOffering').invalid && formData.get('ServiceOffering').touched && formData.get('ServiceOffering').errors)||flag">
                      <div class="error" *ngIf="formData.get('ServiceOffering').hasError('required')">Service Offering
                        is
                        required</div>
                    </div>


                  </div>

                </div>

                <div class="row">

                  <div class="col-4 mb-2">
                    <div>
                      <span class="labelName">Competency <sup class="requiredStar">*</sup></span>
                    </div>

                    <mat-form-field class="custom_select "
                      [class.is-invalid]="formData.get('Competency').invalid && formData.get('Competency').touched && formData.get('Competency').errors">
                      <mat-select placeholder="Select the data.." formControlName="Competency"
                        (selectionChange)="setSubServiceLineValues($event)" [(ngModel)]="this.data.competency">
                        <mat-option *ngFor="let category of serviceLines"
                          [value]="category.id">{{category.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div
                      *ngIf="(formData.get('Competency').invalid && formData.get('Competency').touched && formData.get('Competency').errors)||flag">
                      <div class="error" *ngIf="formData.get('Competency').hasError('required')">Competency is
                        required</div>
                    </div>

                  </div>
                  <div class="col-4">
                    <div>
                      <span class="labelName">Sub Competency <sup class="requiredStar">*</sup></span>
                    </div>

                    <mat-form-field class="custom_select"
                      [class.is-invalid]="formData.get('SubCompetency').invalid && formData.get('SubCompetency').touched && formData.get('SubCompetency').errors">
                      <mat-select placeholder="Select the data.." formControlName="SubCompetency"
                        [(ngModel)]="this.data.subCompetency">
                        <mat-option *ngFor="let category of subServiceValues"
                          [value]="category.id">{{category.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <div
                      *ngIf="(formData.get('SubCompetency').invalid && formData.get('SubCompetency').touched && formData.get('SubCompetency').errors)||flag">
                      <div class="error" *ngIf="formData.get('SubCompetency').hasError('required')">Sub Competency is
                        required</div>
                    </div>

                  </div>

                </div>

                <div class="pb-3 mt-4 border-top"></div>

                <div class="row">
                  <div class="col-12 col-md-4 mb-2">
                    <div class="pr-2">
                      <div><span class="labelName">Contact Person <sup class="requiredStar">*</sup></span></div>

                      <input type="text" class="form-control"
                        [class.is-invalid]="formData.get('contactPerson').invalid && formData.get('contactPerson').touched && formData.get('contactPerson').errors"
                        (keyup)="Onchange()" placeholder="Enter Contact Person" maxlength="40"
                        (input)="getFilteredValues($event.target.value)" (onfocus)="getFilteredValues('')"
                        [matAutocomplete]="partner" formControlName="contactPerson">
                    </div>
                    <mat-autocomplete autoActiveFirstOption #partner="matAutocomplete"
                      (optionSelected)='setCurrentEmployee($event.option.id)'>
                      <mat-option *ngFor="let partner of filteredValues" [id]="partner.employeeId"
                        [value]="partner.name">
                        {{partner.name}} ({{partner.employeeId}})
                      </mat-option>
                    </mat-autocomplete>
                    <div
                      *ngIf="(formData.get('contactPerson').invalid && formData.get('contactPerson').touched && formData.get('contactPerson').errors)||flag">
                      <div class="error" *ngIf="formData.get('contactPerson').hasError('required')">Contact Person is
                        required</div>
                      <div class="error" *ngIf="formData.get('contactPerson').hasError('pattern')">Contact Person is
                        Invalid</div>
                    </div>

                  </div>

                  <div class="col-md-4 mb-2">
                    <div><span class="labelName">Thumbnail <sup class="requiredStar">*</sup></span></div>
                    <div class="custom-file pr-2">
                      <input type="file" class="custom-file-input fileInput"
                        [class.is-invalid]="(formData.get('logo').invalid && formData.get('logo').touched && formData.get('logo').errors) || this.thumbnail"
                        accept=".png,.jpg,.jpeg" formControlName="logo" (change)="onFileChange($event.target?.files)"
                        id="logoFile">
                      <label class="custom-file-label fileLabel" for="logoFile">{{selectedFiles[0]?.name}}</label>
                      <ng-template #showEmpty>
                        <label class="custom-file-label fileLabel" for="logoFile">Choose logo</label>
                      </ng-template>
                    </div>
                    <div class="error" *ngIf="this.thumbnail">Only png,jpg,jpeg file types are allowed</div>
                    <div
                      *ngIf="((formData.get('logo').invalid && formData.get('logo').touched && formData.get('logo').errors)||flag) && !this.thumbnail">
                      <div class="error" *ngIf="!selectedFiles[0]?.name">Thumbnail is required</div>
                    </div>
                    <!-- <select class="form-control" formControlName="Domain" [ngClass]="a?((a.Domain)?'':'is-invalid'):''"
                    (change)="domainChange()">
                    <option value="" disabled selected hidden>--Select Domain--</option>
                    <option *ngFor="let category of domains" [value]="category">{{category}}</option>
                  </select>
                  <div
                    *ngIf="(formData.get('Domain').invalid && formData.get('Domain').touched && formData.get('Domain').errors)||flag">
                    <div class="error" *ngIf="formData.get('Domain').hasError('required')">Domain is
                      required</div>
                  </div> -->
                  </div>

                  <div class="col-md-4">
                    <div><span class="labelName">Upload Artifactory <sup class="requiredStar">*</sup></span></div>
                    <div class="custom-file pr-2">
                      <input type="file" class="custom-file-input"
                        [class.is-invalid]="(formData.get('filebase64').invalid && formData.get('filebase64').touched && formData.get('filebase64').errors) || this.tfile"
                        accept=".pptx,.pdf,.docx,.xlsx" formControlName="filebase64"
                        (change)="onFileChange1($event.target?.files)" id="logoFile">
                      <label class="custom-file-label fileLabel" for="logoFile">{{selectedFiles1[0]?.name}}</label>
                      <ng-template #showEmpty>
                        <label class="custom-file-label fileLabel" for="logoFile">Choose file</label>
                      </ng-template>
                    </div>
                    <div class="error" *ngIf="this.tfile">Only pptx,docx,xlsx,pdf file types are allowed</div>
                    <div
                      *ngIf="((formData.get('filebase64').invalid && formData.get('filebase64').touched && formData.get('filebase64').errors)||flag) && !this.tfile">
                      <div class="error" *ngIf="!selectedFiles1[0]?.name">Upload Artifactory is required</div>
                    </div>
                    <div *ngIf="isView && project.fileURL != null">
                      <div class="pptLink" (click)="viewFile(project.fileURL)"> View Presentation </div>
                    </div>
                  </div>
                </div>
                <div class="pb-3 mt-4 border-top"></div>

                <div class="row">

                  <div class="col-4">
                    <div class="pr-2">
                      <div><span class="labelName">GitLink </span></div>
                      <input type="text" class="form-control" (keyup)="Onchange()" placeholder="Enter GitLink here"
                        formControlName="GitLink">
                      <div class=""
                        *ngIf="(formData.get('GitLink').invalid && formData.get('GitLink').touched && formData.get('GitLink').errors)||flag">
                        <div class="error"
                          *ngIf="formData.get('GitLink').hasError('pattern')&&formData.get('GitLink').value.length>0">
                          Enter a valid GitLink.</div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4 mb-2">
                    <div>
                      <div><span class="labelName">Tags<sup class="requiredStar">*</sup></span></div>
                      <textarea rows="2" cols="50"
                        [class.is-invalid]="formData.get('TemplateTags').invalid && formData.get('TemplateTags').touched && formData.get('TemplateTags').errors"
                        (keyup)="Onchange()" class="form-control" maxlength="150" formControlName="TemplateTags"
                        placeholder="Enter Tags(Ex : HealthCare, Machine Learning)">
                      </textarea>
                      <div class=""
                        *ngIf="(formData.get('TemplateTags').invalid && formData.get('TemplateTags').touched && formData.get('TemplateTags').errors)||flag">
                        <div class="error" *ngIf="formData.get('TemplateTags').hasError('required')">Tags are
                          required</div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 d-flex">

                    <div class="pr-2 mt-auto">
                      <div class="d-flex align-items-center">
                        <div class="input_group">
                          <label class="radio_button m-0">
                            <mat-checkbox class="custom_mdc_checkbox custom_mdc_checkbox2"
                              formControlName="changesAllowed" id="customCheck2">
                              <span class="fs-12">Changes Allowed</span>
                              <span class="date-value related-wrap info" [matTooltip]="'If checked, File can be edited'"
                                matTooltipClass="tooltip-list" placement="top bottom" triggers="manual"
                                (click)="tooltipTags.open()" #tooltipTags (mouseleave)="tooltipTags.close()"
                                (mouseover)="tooltipTags.open()">
                                <!-- <ng-template #projectTagsTooltip>{{"If checked,File can be edited"}}</ng-template> -->
                                <span class="info_icon">info</span>
                              </span>
                            </mat-checkbox>
                          </label>
                        </div>
                        <!-- </label> -->
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </form>

        <div mat-dialog-actions class="popup-buttons d-flex justify-content-end">
          <button type="button" class="custom_btn inverted_btn_base mr-3" id="inv_setup_cancel" data-backdrop="static"
            data-keyboard="false" (click)="cancel()">{{'Cancel'}}</button>
          <button type="button" class="custom_btn primary_btn_base" id="inv_setup_save" data-backdrop="static"
            [disabled]="!hasApproval" [ngStyle]="{
              'opacity': hasApproval ? '1' : '0.5',
              'cursor': hasApproval ? 'pointer' : 'default'}" 
            data-keyboard="false" (click)="OnSubmit()">Submit</button>
        </div>

      </div>
    </div>
  </div>
</div>